import styled from 'styled-components';

export const WorkOrderListFilter = styled.div``;
